export default {
  // Show access denied notice on depo page visit
  showDepoAccessDenied: false,
  // Active ajax requests pool
  activeAjax: [],
  // Trigger to fire the tour
  tourState: 0,
  // Number of currently running xhr requests
  xhrActiveNum: 0,
  // If some object is loading now
  objIsLoading: false,
  apiUrl: process.env.NODE_ENV !== 'production'
    ? 'http://localhost/' : 'https://api.ipuniversity.ru/',
  // http://devapi.ipuniversity.ru/ || https://api.ipuniversity.ru/
  showLogs: false, // Show hide app level logs in browser window
};



// WEBPACK FOOTER //
// ./src/store/state.js